export default function SvgKey() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 26C5.83143 26 0 20.1686 0 13C0 5.83143 5.83143 0 13 0C20.1686 0 26 5.83143 26 13C26 20.1686 20.1686 26 13 26ZM13 0.720571C6.22886 0.720571 0.720571 6.22886 0.720571 13C0.720571 19.7711 6.22886 25.2794 13 25.2794C19.7711 25.2794 25.2794 19.7711 25.2794 13C25.2794 6.22886 19.7711 0.720571 13 0.720571Z"
        fill="#F3F3F3"
      />
      <g clipPath="url(#clip0_803_25)">
        <path
          d="M13.3791 11.8333C12.9008 10.4742 11.6058 9.5 10.0833 9.5C8.15242 9.5 6.58325 11.0692 6.58325 13C6.58325 14.9308 8.15242 16.5 10.0833 16.5C11.6058 16.5 12.9008 15.5258 13.3791 14.1667H15.9166V16.5H18.2499V14.1667H19.4166V11.8333H13.3791ZM10.0833 14.1667C9.44159 14.1667 8.91659 13.6417 8.91659 13C8.91659 12.3583 9.44159 11.8333 10.0833 11.8333C10.7249 11.8333 11.2499 12.3583 11.2499 13C11.2499 13.6417 10.7249 14.1667 10.0833 14.1667Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_803_25">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
